/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function FanIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 18 18'
      {...props}
    >
      <path
        fill='#9DA1A9'
        d='M9.921 16.456q-.916.246-1.539-.175a1.92 1.92 0 0 1-.81-1.12 2.2 2.2 0 0 1-.037-.963q.089-.495.443-.899.327-.356.464-.818.137-.46.106-.933l-.244-.05a1 1 0 0 1-.231-.073l-1.495 1.036q-.276.19-.544.338-.269.15-.574.231-1.132.303-2.268-.451-1.136-.755-1.646-2.66-.246-.915.174-1.539t1.104-.806q.467-.125.971-.038.506.086.908.44.357.328.817.465.461.135.934.106l.05-.245q.025-.121.073-.231L5.54 6.577a7 7 0 0 1-.339-.545 2.5 2.5 0 0 1-.225-.556q-.309-1.149.446-2.286.755-1.136 2.66-1.646.915-.245 1.539.175.622.42.805 1.103.126.466.04.972a1.8 1.8 0 0 1-.441.907q-.328.357-.465.818a2.7 2.7 0 0 0-.106.933l.245.05q.121.025.231.073l1.49-1.054q.276-.189.538-.327.261-.137.566-.22 1.455-.39 2.497.622 1.041 1.01 1.436 2.485.245.915-.202 1.546a2.02 2.02 0 0 1-2.075.845 1.87 1.87 0 0 1-.88-.448 2.1 2.1 0 0 0-.818-.464 2.7 2.7 0 0 0-.933-.106l-.05.244a1 1 0 0 1-.073.231l1.036 1.494q.185.26.326.5.142.241.219.529.33 1.162-.417 2.326-.747 1.163-2.67 1.678m-.63-6.378q.45-.12.679-.519t.11-.848q-.12-.45-.52-.68a1.08 1.08 0 0 0-.847-.109q-.45.12-.68.52-.23.397-.11.847t.52.68q.399.23.848.11'
      />
    </svg>
  )
}
